import React from 'react';

import { FiPackage } from 'react-icons/fi';

import { Badge } from '@/components/shadcn/ui/badge';

const BuildDetailsNpmLink: React.FC<{
  pkgMirror: string;
}> = ({ pkgMirror }) => {
  return (
    <a href={pkgMirror} target="_blank" rel="noopener noreferrer">
      <Badge className="cursor-pointer gap-1">
        <FiPackage className="size-3" />
        NPM Package
      </Badge>
    </a>
  );
};

export default BuildDetailsNpmLink;
